<template>
    <div>
        <div class="landing__main p--0">
            <div class="landing__main__bg relative noisy">
                <div class="landing__main__bg__inner landing-px-2">
                    <LandingHeader :window-width="windowWidth" />
    
                    <div id="hero" class="landing__hero__wrap landing__section">
                        <div class="terms__header">
                            <h1 class="text--heading text--6xl text--neutral-600">
                                Privacy policy
                            </h1>
                            <p class="text--neutral-800 landing__hero__text m-w-unset text--xl">
                                We respect your privacy and are committed to protecting your personal information.
                            </p>
                            <p class="text--sm mt--30 text-blue">
                                Last updated: July 1st 2025
                            </p>
                        </div>
                        <div class="terms__body">
                            <div>
                                <div v-for="(item, index) in policies" :key="item.heading" class="terms__list__item">
                                    <h2>{{ index + 1 }}. {{ item.heading }}</h2>
                                    <p class="">
                                        {{ item.content }}
                                    </p>
                                    <ul class="mt--5">
                                        <li v-for="innerItem in item.subList" :key="innerItem.text">
                                            <span class="text--semi--bold">{{ innerItem.id }}</span> <span>{{ innerItem.text }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LandingFooter 
                    id="footer" 
                    class="terms__footer"
                    :show-bg-toggle="true" 
                />
            </div>
            <div />
        </div>
    </div>
</template>

<script>
import { policies } from "@/utils/dummy";
import LandingFooter from "@/components/home/LandingFooter.vue";
import LandingHeader from "@/components/home/LandingHeader.vue";

export default {
    name: "Terms",

    components: {
        LandingFooter,
        LandingHeader,
    },

    data() {
        return {
            windowWidth: window.innerWidth,
            policies,
        };
    },

    async mounted() {        
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize); 
    },


    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
    },
};
</script>